<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

// Define props
const props = defineProps({
    description: {
        type: String,
        default: '',
        validator(rawValue) {
            return rawValue === undefined || typeof rawValue === 'string'
        }
    }
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Markdown
const { $md } = useNuxtApp()
const shopDescription = computed(() => $md.render(props?.description || ''))

const shopDescriptionHeadline = computed(() => {
    return {
        title: staticKeys.value?.shops_details_details_headline_web_markdown,
        renderSplit: true
    }
})
</script>

<template>
    <section class="shop-description-wrapper">
        <ContentHeadline :content-headline-config="shopDescriptionHeadline" />

        <div class="shop-description-content" v-html="shopDescription" />
    </section>
</template>

<style lang="scss">
.shop-description-wrapper {
    margin: 0 auto 20px;

    @include bp(medium1) {
        margin: 0 auto 40px;
        color: $body-text;
    }

    @include bp(large2) {
        margin: 60px auto;
    }
}

.shop-description-content {
    color: $shop-description-content;
    max-width: $component-width;
    margin: 0 auto;

    @include rte-text;
}
</style>
